<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" class="modal-content">
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">{{rowNumber? 'Edit' : 'Add'}} Registrant</h3>

      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <form #theForm="ngForm" novalidate>
    <div class="modal-body">
      <div class="form-group">
        <label for="package">Package</label>
        <select class="form-control" [disabled]="registrantPurchase.hasAdditionalTransactionsForUserPackage" required (change)="packageChanged()" [(ngModel)]="registrantPurchase.package" name="package">
          <option [ngValue]="null">Please Choose...</option>
          <option [ngValue]="package" *ngFor="let package of packages">
            {{ package.hasGroupDiscounts ? '* ' : '' }}{{ package.category }} > {{ package.name }}
            <span *ngIf="package.ceuOverride && !package.noCEUs">({{ package.ceuOverride }} CEUs)</span>
            <span *ngIf="!package.noCEUs && !package.ceuOverride">({{ package.totalCEUs |ceuCount }} CEUs)</span>
            <span *ngIf="package.noCEUs">(No CEUs)</span>
          </option>
        </select>
        <div class="invalid-message">Package is Required</div>
        <div *ngIf="anyPackageHasGroupDiscounts" class="mt-1">
          (* indicates a package with group discounts available)
        </div>
        <div *ngIf="anyPackageHasGroupDiscounts">
          <a role="button" class="text-primary cursor-pointer" (click)="openGroupDiscountDetails()">Group Discount Details</a>
        </div>
      </div>
      <page-load-header *ngIf="packageChanging"></page-load-header>
      <ng-container *ngIf="!packageChanging && selectedPackage?.id">
        <div class="form-row mb-2">
          <div *ngIf="selectedPackage.memberPricing && !conference.externalMemberLookup" class="col-12 mb-2">
            <label for="uname1"> Is the registrant a member of {{ conference.organization.shortName }}?</label>
            <select class="form-control" (change)="calculatePrice()" required [(ngModel)]="registrantPurchase.isMember" name="isMember">
              <option [ngValue]="null">Please choose....</option>
              <option [ngValue]="true">Yes ({{ selectedPackage.price | currency: currencyCode:'symbol' }})</option>
              <option [ngValue]="false">No ({{ selectedPackage.nonMemberPrice | currency: currencyCode:'symbol' }})</option>
            </select>
            <div class="invalid-message">
              <div>Please indicate membership status</div>
            </div>
          </div>
          <div *ngIf="selectedPackage.memberPricing && conference.externalMemberLookup && !isExistingRecord" class="col-12 mb-4">
            <label class="d-block" for="uname1"> If the registrant is a {{ conference.organization.shortName }} member, they are eligible for a discount.<br/>Click Below to look up this registrant's membership and apply the discount.</label>
            <button *ngIf="!registrantPurchase.memberLookupResult" class="btn btn-admin-primary" type="button" (click)="checkMembership()">Lookup Membership</button>
            <div *ngIf="registrantPurchase.memberLookupResult" class="">
              <div class="input-group mb-3">
                <input class="form-control" readonly value="Linked Member: {{ registrantPurchase.memberLookupResult.firstName }} {{ registrantPurchase.memberLookupResult.lastName }}" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" (click)="registrantPurchase.memberLookupResult = null; registrantPurchase.isMember = false; calculatePrice()" type="button" id="button-addon2">Unlink</button>
                </div>
              </div>
            </div>
            <div class="invalid-message">
              <div>Please indicate registrant's membership status</div>
            </div>
          </div>
          <div *ngIf="selectedPackage.memberPricing && conference.externalMemberLookup && isExistingRecord && registrantPurchase.isMember" class="col-12 mb-4">
            <span class="text-success mr-1"><i class="fas fa-check-circle"></i></span>Registrant has qualified for the member rate
          </div>
          <div class="form-group col-md-4">
            <label for="firstName">First Name</label>
            <input type="text" [disabled]="isExistingRecord" class="form-control" required [(ngModel)]="registrantPurchase.firstName" (blur)="updateSurveyQuestionsFromRegistrant()" name="firstName" />
            <div class="invalid-message">First Name is Required</div>
          </div>
          <div class="form-group col-md-4">
            <label for="lastName">Last Name</label>
            <input type="text" [disabled]="isExistingRecord" class="form-control" required [(ngModel)]="registrantPurchase.lastName" (blur)="updateSurveyQuestionsFromRegistrant()" name="lastName" />
            <div class="invalid-message">Last Name is Required</div>
          </div>
          <div class="form-group col-md-4">
            <label for="pronouns">Pronouns</label>
            <input type="text" class="form-control" [(ngModel)]="registrantPurchase.pronouns" name="pronouns" />
          </div>
          <div class="form-group col-md-6">
            <label for="email">Email</label>
            <input type="email" [disabled]="isExistingRecord" class="form-control" required email pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" [(ngModel)]="registrantPurchase.email" (blur)="updateSurveyQuestionsFromRegistrant()" name="email" />
            <div class="invalid-message">Email is Required</div>
          </div>
          <div *ngIf="selectedPackage.ceUsAreExtra && !registrantPurchase.registrantPurchasedCEUsSeparately" class="col-md-6 mb-2">
            <label for="purchaseCEUs"> Purchase CEUs for this registrant?</label>
            <select class="form-control" (change)="calculatePrice()" required [(ngModel)]="registrantPurchase.purchaseCEUs" name="purchaseCEUs">
              <option [ngValue]="null">Please choose....</option>
              <option [ngValue]="true">Yes (+{{ (!selectedPackage.memberPricing || registrantPurchase.isMember ? selectedPackage.ceuPrice : selectedPackage.ceuNonMemberPrice) | currency: currencyCode:'symbol' }})</option>
              <option [ngValue]="false">No</option>
            </select>
            <div class="invalid-message">
              <div>Please indicate if you want CEUs for this registrant.</div>
            </div>
          </div>
          <div *ngIf="selectedPackage.ceUsAreExtra && registrantPurchase.registrantPurchasedCEUsSeparately" class="col-md-6 mb-2">
            <label>&nbsp;</label>
            <div class="form-control" style="border: none;"><span class="text-success mr-1"><i class="fas fa-check-circle"></i></span>Registrant purchased CEUs separately.</div>
          </div>
        </div>
        <div *ngIf="selectedPackage.addOns.length > 0" class="form-row">
          <div class="col-md-12 mb-3">
            <div class="d-block"><strong>Add-ons (Optional):</strong></div>
  
            <!-- Checkbox Switch -->
            <ng-container *ngFor="let addon of selectedPackage.addOns; let i = index">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="addons{{ i }}" id="customSwitch{{ i }}" />
                <label class="custom-control-label" for="customSwitch{{ i }}">
                  <span class="d-block"
                    >{{ addon.name }} <span *ngIf="addon.price > 0">(+{{ addon.price | currency: currencyCode:'symbol' }})</span><span *ngIf="addon.price == 0">(FREE)</span></span
                  >
                  <small class="d-block text-muted">{{ addon.description }}</small>
                </label>
              </div>
              <!-- End Checkbox Switch -->
  
              <hr class="my-2" />
            </ng-container>
          </div>
        </div>
        <div *ngIf="selectedPackage.eventAddons.length > 0" class="form-row">
          <div class="col-md-12 mb-3">
            <div class="d-block"><strong>Optional Events & Workshops:</strong></div>
            <div *ngIf="toggleEventAddOnOptions" class="alert alert-warning">
              Would you like to add any workshops for this registrant? <button type="button" (click)="showWorkshops = !showWorkshops" class="btn d-block btn-xs btn-admin-primary"><span *ngIf="showWorkshops">Hide</span><span *ngIf="!showWorkshops">Show</span> Workshops</button>
            </div>
            <div *ngIf="selectedPackage.eventAddonDiscountQuantityThreshold" class="alert alert-warning" role="alert">Purchase 2 or more workshops and receive a {{ selectedPackage.eventAddonDiscountAmount | percent }} discount!</div>
            <!-- Checkbox Switch -->
            <ng-container *ngIf="showWorkshops || !toggleEventAddOnOptions">
              <ng-container *ngFor="let addon of selectedPackage.eventAddons; let i = index">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="eventAddons{{ i }}" id="customEventSwitch{{ i }}" />
                  <label class="custom-control-label" for="customEventSwitch{{ i }}">
                    <span *ngIf="addon.memberPricing && registrantPurchase.isMember" class="d-block"> {{ addon.title }} (+{{ addon.memberPrice | currency: currencyCode:'symbol' }})</span>
                    <span *ngIf="!addon.memberPricing || !registrantPurchase.isMember" class="d-block"> {{ addon.title }} (+{{ addon.price | currency: currencyCode:'symbol' }})</span>
                    <small class="d-block font-weight-semi-bold">{{ addon.formattedFullTime }}</small>
                    <small class="d-block text-muted">{{ addon.instructor.fullNameWithCredentials }}</small>
                  </label>
                  <a href="javascript:void(0);" (click)="showDetails(addon)" class="d-block">View Details</a>
                </div>
                <!-- End Checkbox Switch -->
  
                <hr class="my-2" />
              </ng-container>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="startTimes.length > 0 && !isExistingRecord">
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <div class="d-block"><strong>Reserve Breakouts:</strong></div>
              <div class="d-block"><small> Please select one breakout session at each time slot below for a total of six selections. Please note, there is a scroll on each session for a total of (14-16) choices at each time. All other conference sessions (with the exception of workshops) are pre-selected and included.</small></div>
            </div>
          </div>
          <div class="form-row" *ngFor="let addon of startTimes; let i = index">
            <div class="col-md-12 mb-3">
              <!-- Checkbox Switch -->
              <div class="mb-2">
                <label for="uname1">{{ addon.key() }}</label>
                <event-picker class="form-control" required (change)="breakoutChanged()" [data]="addon.getSource()" [valuePrimitive]="true" [(ngModel)]="reservedBreakouts[i]" name="reservedBreakout{{ i }}" textField="title" valueField="id"></event-picker>
                <div class="invalid-message">
                  <div>This breakout is required</div>
                </div>
                <!-- End Checkbox Switch -->
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedPackage?.customQuestionSurveyId">
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <survey class="survey-embed" [model]="surveyModel"></survey>
            </div>
          </div>
        </ng-container>
      </ng-container>
      
      
      <div *ngIf="errorMessage" class="alert alert-primary mt-2" role="alert">
        {{ errorMessage }}
      </div>
      <div class="form-group mt-3">
        <button *ngIf="selectedPackage?.id" type="button" class="btn btn-primary" data-dismiss="modal" aria-hidden="true" [promiseBtn]="submitComplete" (click)="addRegistrantClicked()">{{rowNumber? 'Update' : 'Add'}} Registrant - {{ actualPrice | currency: currencyCode:'symbol' }}</button>
        <button type="button" class="btn btn-outline-danger float-right" (click)="activeModal.dismiss()">Cancel</button>
        <div *ngIf="selectedPackage?.id">(any promo codes or group discounts will be applied to group registration total)</div>
      </div>
    </div>
  </form>
</div>
